module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-wc-fill-6c06abac.svg";